import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { MyErrorStateMatcher } from 'src/app/utils/errorStateMatcher';

export interface DialogDataConfirmSave {
  reason: string;
  showReason: boolean;
}

@Component({
    selector: 'app-execution-edit-dialog-confirm-save',
    templateUrl: 'execution-edit-dialog-confirmSave.component.html',
    standalone: false,
})
export class ExecutionEditConfirmSaveComponent {

  matcher = new MyErrorStateMatcher();
  form: UntypedFormGroup;
  inSignState: boolean;

  constructor(
    fb: UntypedFormBuilder,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ExecutionEditConfirmSaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataConfirmSave) {

    this.form = fb.group({
      reason: [this.data.reason, this.data.showReason ? [Validators.required] : []]
    });
  }

  onOkClick(): void {

    if (!this.form.valid) {
      this.snackBarService.sendError(this.translate.instant('executionEdit.dialog.confirmSave.form.error.reason') as string);
      return;
    }

    this.dialogRef.close(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
